/*
  PureNADH cart drawer v2 - behaviour.
  Server-rendered section + Ajax Cart API + Bundled Section Rendering.
  No dedup/hang patches needed: every change re-renders the section from the server.

  Pairs with: sections/cart-drawer-pn.liquid + assets/cart-drawer-pn.css
  Section name MUST be 'cart-drawer-pn' (matches the .liquid filename).

  2026-09-06 cart audit batch (2-CHANGES/2026-09-06_cart-audit/REPORT.md, Esefov incident "zakovao se na mobitelu"):
   - open() idempotentan + fokus na pravi X; .then(open) maknut sa 4 mrezna lanca (drawer se vise ne otvara sam nakon sto ga kupac zatvori)
   - applyPanel mijenja samo body + footer (header i X se nikad ne zamjenjuju; iOS tap na X vise ne propada usred re-rendera),
     odbija neispravan panel, cuva scrollTop, seq guard (samo najnoviji odgovor crta), 15 s timeout + content-type provjera (pnFetch/isJson)
   - swipe-to-dismiss: touchcancel/orientationchange/visibilitychange reset, 8px slop, jedan prst, kontrole ne pokrecu drag
   - qty gumbi: busy flag umjesto disabled (iOS smart zoom na dupli tap), Remove busy guard, sub toggle revert na gresku
   - Checkout gumb se resetira na pageshow/pagehide/visibilitychange (bfcache povratak)
   - add.js non-JSON (bot challenge) -> nativni submit forme umjesto stale drawera
   - toast na rootu (prezivljava re-render, ne prekriva Checkout); telemetrija pn_cart (open/close via, stuck, x_covered, ...)
   - popup (pn-welcome-popup.liquid) ceka 'pncart:close' dok je kosarica otvorena
  2026-09-06 batch 2 (P2): iOS body lock na <=480px (html overflow:hidden se na iOS-u ignorira), Android Back / iOS edge-swipe
   zatvara drawer umjesto da napusta stranicu (pushState/popstate), gumb "Continue shopping" u footeru i praznom stanju.
*/
(function () {
  if (window.__pnCartV2) return;
  window.__pnCartV2 = true;

  // 2026-07-12: dok je cart drawer otvoren, sakrij chat balon (ScaleTrack .pnw-launcher)
  // - preklapa Checkout dugme, posebno na mobilnom. Klasa se toggla u open()/close().
  try {
    var pnwHide = document.createElement('style');
    pnwHide.textContent = 'html.pncart-open .pnw-launcher, html.pncart-open #pnw-label, html.pncart-open .pnw-teaser{opacity:0 !important;visibility:hidden !important;pointer-events:none !important;transition:opacity .2s ease,visibility .2s ease;}';
    document.head.appendChild(pnwHide);
  } catch (e) {}

  var SECTION = 'cart-drawer-pn';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Render the cart section from the shop root. Some custom page templates (e.g. /pages/ landers)
  // return an EMPTY body for `?sections=cart-drawer-pn`, which left the drawer without a footer/checkout.
  // The drawer content is cart-global, so rendering from the root is identical and works everywhere.
  var SEC_URL = root;
  // theme section holding the cart icon - so we refresh its count badge after every cart change
  var HEADER_SECTION = (function(){ var h=document.getElementById('cart-icon-bubble'); var s=h && h.closest('[id^="shopify-section-"]'); return s ? s.id.replace('shopify-section-','') : null; })();
  function sectionList(){ return HEADER_SECTION ? SECTION+','+HEADER_SECTION : SECTION; }
  function syncCartIcon(html){ if(!html) return; var t=document.createElement('div'); t.innerHTML=html; var fresh=t.querySelector('#cart-icon-bubble'), cur=document.getElementById('cart-icon-bubble'); if(fresh && cur) cur.innerHTML=fresh.innerHTML; }

  var SIZE   = { '50884489544000':30, '50884489576768':60, '50884489609536':90 };
  var BYSIZE = { 30:'50884489544000', 60:'50884489576768', 90:'50884489609536' };
  var SIZES  = [30,60,90];
  // 2026-10-01 (Esef, IM8 obrazac): one-time SAMO 30-day $69.99; pretplata 30-day $49.99 i 90-day $119.99. 90-day one-time ($149.99,
  // dodan 30.9. navecer) se vise ne nudi: PRICE.onetime[90] ostaje samo za vec postojece linije iz starih linkova.
  // 60-day i one-time 90-day NISU u ponudi (varijante postoje radi starih ugovora i direktnih linkova): drawer ih
  // prikazuje ako su vec u korpi, ali ih nikad ne preporucuje niti na njih prebacuje. OFFER = sto se smije nuditi.
  var OFFER  = { onetime:[30], sub:[30,90] };
  var PRICE  = { onetime:{30:69.99,60:109.99,90:149.99}, sub:{30:49.99,60:69.99,90:119.99} };
  // 2026-07-16: legacy 3x3 plan matrix (size x cadence) was cleaned up in admin -
  // each size now has exactly ONE live plan (Subscribe & Save, cadence = supply
  // length: every 30/60/90 days). Every freq key maps to that single plan so any
  // remaining freq-based code path resolves to a valid plan.
  var PLANS  = { 30:{'1':'693418426688','2':'693418426688','3':'693418426688'}, 90:{'1':'693418524992','2':'693418524992','3':'693418524992'} }; // 60-day plan vise nije u ponudi
  // reverse map: a cart line's plan id -> its cadence, so an upgrade keeps the same delivery frequency
  var PLAN_FREQ = { '693418426688':'1','693418459456':'2','693418524992':'3' };
  // business rule (same as the PDP buy box): delivery cadence follows the supply size
  // 30-day supply -> every 1 month, 60-day -> every 2 months, 90-day -> every 3 months
  var SIZE_FREQ = { 30:'1', 60:'2', 90:'3' };
  var PERCAP = { onetime:{30:2.33,60:1.83,90:1.67},    sub:{30:1.67,60:1.17,90:1.33} };
  // usteda pretplate prema one-time cijeni ISTE varijante (30: 69.99-49.99; 90 samo za naslijedjene one-time 90 linije iz starih linkova); 60-day nema pretplatu u ponudi
  var SAVE   = { 30:20.00, 90:30.00 };
  var SUPPLY = { 30:'1-month supply', 60:'2-month supply', 90:'3-month supply' };

  var money = function (n) { return '$' + Number(n).toFixed(2); };
  var $  = function (s, r) { return (r||document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  var drawer = function () { return $('[data-pncart]'); };
  // 2026-09-06: /cart stranica renderira isti panel staticno (sections/main-cart-pn.liquid, klasa pncart--page):
  // tamo je drawer() samo render-target, nikad modal - open/close/focus-trap/swipe/backdrop su no-op.
  var isStatic = function (d) { return !!(d && d.classList && d.classList.contains('pncart--page')); };

  var mutationTail=Promise.resolve(), mutationCount=0, closeEpoch=0;
  var SWAP_STORAGE='pncart_pending_swap_v1', REFRESH_STORAGE='pncart_needs_refresh_v1', pendingSwap=null, needsCartRefresh=false;
  try{ needsCartRefresh=sessionStorage.getItem(REFRESH_STORAGE)==='1'; }catch(e){}
  try{ pendingSwap=JSON.parse(sessionStorage.getItem(SWAP_STORAGE)||'null'); }catch(e){}
  if(pendingSwap && (!pendingSwap.source || !pendingSwap.target || !SIZE[pendingSwap.source.variant] || !SIZE[pendingSwap.target.variant] || !(pendingSwap.quantity>0) || !(pendingSwap.sourceQuantity>0) || !(pendingSwap.targetQuantity>=0))) pendingSwap=null;
  var seq=0;                      // response ordering: only the newest request may paint the panel
  var resetDrag=function(){};     // assigned by the swipe block below
  // Shopify cart endpoints (/cart/add.js, change.js, update.js, clear.js, cart.js) answer with text/javascript; only ?sections= is application/json.
  // A bot challenge is text/html. So "API answer" = json OR javascript (HOTFIX 6.9. 17:00: the json-only check made every Remove/qty/toggle show an error toast).
  function isJson(r){ return /\b(json|javascript)\b/i.test((r && r.headers && r.headers.get('content-type'))||''); }
  function pnFetch(url, opts){    // 15 s timeout: a stalled socket must not keep buttons dead for a minute
    opts=opts||{}; var c=('AbortController' in window)?new AbortController():null, tm=null;
    if(c){ opts.signal=c.signal; tm=setTimeout(function(){ try{ c.abort(); }catch(e){} }, 15000); }
    return fetch(url,opts).then(function(r){
      // Keep the timeout active through body delivery, not just response headers.
      return r.text().then(function(body){ return {ok:r.ok,status:r.status,headers:r.headers,json:function(){ return Promise.resolve().then(function(){ return JSON.parse(body); }); }}; });
    }).then(function(r){ if(tm) clearTimeout(tm); return r; },function(e){ if(tm) clearTimeout(tm); throw e; });
  }
  // telemetrija: dataLayer event pn_cart + Clarity custom event/tag (pncart_issue) - da sljedeci incident bude reproducibilan
  function tel(ev, data){
    try{ var o={pncart_action:ev}; if(data){ for(var k in data){ if(Object.prototype.hasOwnProperty.call(data,k)) o[k]=data[k]; } } if(window.pnTrack){ window.pnTrack('pn_cart', o); } else { o.event='pn_cart'; (window.dataLayer=window.dataLayer||[]).push(o); } }catch(e){}
    try{ if(typeof window.clarity==='function'){ window.clarity('event','pncart_'+ev); if(ev==='stuck'||ev==='x_covered'||ev==='x_offscreen'||ev==='close_control_missing') window.clarity('set','pncart_issue',ev); } }catch(e){}
  }
  var openedAt=0, lastTouch=0, stuckTimer=null, openVia='';
  // page lock: html overflow:hidden + na mobilnom body position:fixed (iOS ignorira overflow na html); refcount-safe
  var lockY=0, locked=false;
  function lockPage(on){
    var de=document.documentElement, b=document.body, mobile=window.innerWidth<=480;
    if(on){ if(locked) return; locked=true; lockY=window.scrollY||0; de.style.overflow='hidden';
      /* body position:fixed ISKLJUCEN (6.9. 16:45): na iOS Safariju je sheet bio pomaknut prema gore za scrollY (fixed potomci nasljedjuju pomak
         kad neki predak ima transform/filter, npr. a11y widget wrapper). Ostaje samo html overflow hidden + touch-action pravila iz CSS-a. */ }
    else { if(!locked) return; locked=false; de.style.overflow='';
      if(b.style.position==='fixed'){ b.style.position=''; b.style.top=''; b.style.left=''; b.style.right=''; b.style.width=''; window.scrollTo(0, lockY); } }
  }
  // Back gesta zatvara drawer: jedan history entry dok je otvoren (bez gomilanja), popstate zatvara, close() ga skida
  var closingFromPop=false, expectPop=false;
  function pushCartState(){ try{ if(!(history.state && history.state.pncart)) history.pushState({pncart:1}, ''); }catch(e){} }
  function popCartState(){ if(closingFromPop) return; try{ if(history.state && history.state.pncart){ expectPop=true; history.back(); } }catch(e){} }
  window.addEventListener('popstate', function(){
    var d=drawer(), isOpen=d && !isStatic(d) && d.getAttribute('aria-hidden')==='false';
    if(expectPop){ expectPop=false; if(isOpen) pushCartState(); return; }   // our own history.back() after close(); if the shopper re-opened meanwhile, keep the entry
    if(isOpen){ closingFromPop=true; try{ close('history'); }finally{ closingFromPop=false; } }
  });
  function checkExit(){
    var d=drawer(); if(!d || isStatic(d) || d.getAttribute('aria-hidden')!=='false') return;
    var x=d.querySelector('.pncart__panel [data-pncart-close]'); if(!x){ tel('close_control_missing'); return; }
    var r=x.getBoundingClientRect();
    if(r.width===0 || r.bottom<0 || r.top>window.innerHeight){ tel('x_offscreen',{pncart_t:Math.round(r.top)}); return; }
    var el=document.elementFromPoint(r.left+r.width/2, r.top+r.height/2);
    if(!el || !el.closest('[data-pncart-close]')) tel('x_covered',{pncart_by: el ? (el.id||String(el.className).slice(0,40)) : 'none'});
  }
  document.addEventListener('touchstart', function(){ lastTouch=Date.now(); }, {passive:true, capture:true});
  document.addEventListener('click', function(){ lastTouch=Date.now(); }, true);
  document.addEventListener('keydown', function(){ lastTouch=Date.now(); }, true);
  document.addEventListener('wheel', function(){ lastTouch=Date.now(); }, {passive:true, capture:true});
  document.addEventListener('scroll', function(){ lastTouch=Date.now(); }, {passive:true, capture:true});
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) lastTouch=Date.now(); });

  // korisniku vidljiva greska (toast) - audit fix: greske se vise ne gutaju tiho
  function pnToast(msg){
    try{
      var d=drawer(), isOpen=d && !isStatic(d) && d.getAttribute('aria-hidden')==='false';
      var host=isOpen ? d : document.body;                       // the root keeps its children across applyPanel()
      var foot=isOpen && d.querySelector('.pncart__foot');
      var bottom=(foot ? Math.round(foot.getBoundingClientRect().height)+28 : 24)+'px';
      var t=document.createElement('div'); t.setAttribute('role','alert');
      t.style.cssText='position:fixed;left:50%;bottom:calc('+bottom+' + env(safe-area-inset-bottom));transform:translateX(-50%);pointer-events:none;background:#B42318;color:#fff;font-family:inherit;font-size:14px;font-weight:600;padding:10px 18px;border-radius:10px;z-index:100002;box-shadow:0 6px 20px rgba(0,0,0,.25);max-width:calc(100vw - 32px);text-align:center;';
      t.textContent=msg; host.appendChild(t);
      setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); }, 4000);
    }catch(e){}
  }

  // Keep Shopify's confirmed prices during a request. Discounts can depend on the whole cart.
  var MUTABLE='[data-pncart-remove],[data-pncart-qty],[data-pncart-upgrade],[data-pncart-downsize],[data-pncart-onetime],[data-pncart-subtoggle],[data-pncart-tab]';
  function setCartBusy(on){
    var d=drawer(); if(!d) return;
    if(on) d.setAttribute('data-pncart-busy','true'); else d.removeAttribute('data-pncart-busy');
    var body=d.querySelector('[data-pncart-body]'); if(body) body.setAttribute('aria-busy',on?'true':'false');
    $$(MUTABLE,d).forEach(function(el){ if(on) el.setAttribute('aria-disabled','true'); else el.removeAttribute('aria-disabled'); });
    syncCheckoutAvailability();
  }
  function syncCheckoutAvailability(){
    var blocked=!!(mutationCount || pendingSwap || needsCartRefresh), d=drawer();
    if(d) $$('.pncart__checkout',d).forEach(function(a){
      if(blocked){ if(a.getAttribute('href')) a.setAttribute('data-pncart-checkout-href',a.getAttribute('href')); a.removeAttribute('href'); a.setAttribute('aria-disabled','true'); }
      else { var href=a.getAttribute('data-pncart-checkout-href'); if(href){ a.setAttribute('href',href); a.removeAttribute('data-pncart-checkout-href'); } a.removeAttribute('aria-disabled'); }
    });
    $$('[data-pncart-express]').forEach(function(ex){
      if(blocked){ ex.setAttribute('inert',''); ex.setAttribute('aria-disabled','true'); ex.style.pointerEvents='none'; }
      else { ex.removeAttribute('inert'); ex.removeAttribute('aria-disabled'); ex.style.pointerEvents=''; }
    });
  }
  function cartError(message){ var e=new Error(message); e.cartMessage=message; return e; }
  function saveSwap(value){
    pendingSwap=value;
    try{ if(value) sessionStorage.setItem(SWAP_STORAGE,JSON.stringify(value)); else sessionStorage.removeItem(SWAP_STORAGE); }catch(e){}
    showSwapReview(); syncCheckoutAvailability();
  }
  function markCartNeedsRefresh(value){
    needsCartRefresh=value;
    try{ if(value) sessionStorage.setItem(REFRESH_STORAGE,'1'); else sessionStorage.removeItem(REFRESH_STORAGE); }catch(e){}
    showSwapReview(); syncCheckoutAvailability();
  }
  function refreshConfirmedCart(){
    return getSection().then(function(h){
      if(!h || !applyPanel(h)) throw new Error('cart section unavailable');
      markCartNeedsRefresh(false);
    });
  }
  function showSwapReview(){
    var d=drawer(); if(!d) return;
    var old=d.querySelector('[data-pncart-review]');
    if(!pendingSwap && !needsCartRefresh){ if(old) old.remove(); return; }
    var kind=pendingSwap?'swap':'refresh';
    if(old && old.getAttribute('data-pncart-review-kind')!==kind){ old.remove(); old=null; }
    if(old || mutationCount) return;
    var box=document.createElement('div'); box.className='pncart__review'; box.setAttribute('data-pncart-review',''); box.setAttribute('data-pncart-review-kind',kind); box.setAttribute('role','status');
    var p=document.createElement('p'); p.textContent=pendingSwap?'Your pack change needs a quick check. Review the items before continuing.':'Your item was added. Refresh your cart to review it before continuing.';
    var retry=document.createElement('button'); retry.type='button'; retry.setAttribute('data-pncart-recover',''); retry.textContent=pendingSwap?'Check pack change':'Refresh cart';
    var keep=document.createElement('button'); keep.type='button'; keep.setAttribute('data-pncart-keep',''); keep.textContent='Keep the items shown';
    box.appendChild(p); box.appendChild(retry); if(pendingSwap) box.appendChild(keep);
    var body=d.querySelector('[data-pncart-body]'); if(body) body.insertBefore(box,body.firstChild);
  }
  function queueMutation(work, acceptCurrent){
    mutationCount++; setCartBusy(true);
    var job=mutationTail.then(function(){
      ++seq; // Invalidate any section request started before this mutation.
      if(pendingSwap && !acceptCurrent){
        return recoverSwap().then(function(){ pnToast('Your cart has been checked. Please review the items before continuing.'); });
      }
      if(needsCartRefresh && !acceptCurrent){
        return refreshConfirmedCart().then(function(){ pnToast('Your item was already added. Your cart is now refreshed. Use the cart icon to review it.'); });
      }
      return work();
    });
    var complete=function(){ mutationCount--; setCartBusy(mutationCount>0); showSwapReview(); };
    var result=job.then(function(v){ complete(); return v; },function(e){ complete(); throw e; });
    mutationTail=result.catch(function(){});
    return result;
  }
  function showCartError(err, fallback){ pnToast((err && err.cartMessage)||fallback); if(!(err && err.noRefresh)) refresh(); }

  /* ---------- open / close (with focus management) ---------- */
  var lastFocus = null;
  function focusable(){ var p=$('[data-pncart] .pncart__panel'); return p ? Array.prototype.slice.call(p.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function(el){ return el.offsetParent!==null; }) : []; }
  function open(via)  {
    var d=drawer(); if(!d || isStatic(d)) return;
    if(d.getAttribute('aria-hidden')==='false') return;   // already open: a late network callback must not re-open or overwrite lastFocus
    lastFocus = document.activeElement;
    d.setAttribute('aria-hidden','false');
    lockPage(true);
    document.documentElement.classList.add('pncart-open');
    pushCartState();
    openVia=via||'unknown'; openedAt=lastTouch=Date.now(); tel('open',{pncart_via:openVia, pncart_w:window.innerWidth});
    clearInterval(stuckTimer); stuckTimer=setInterval(function(){
      if(document.hidden) return;                                   // backgrounded tab is not a stuck shopper
      if(Date.now()-lastTouch>60000){ tel('stuck',{pncart_secs:Math.round((Date.now()-openedAt)/1000), pncart_via:openVia}); clearInterval(stuckTimer); }
    }, 5000);
    setTimeout(checkExit, 450);
    var x=d.querySelector('.pncart__panel [data-pncart-close]');
    if(x) setTimeout(function(){ try{ x.focus({preventScroll:true}); }catch(e){ try{ x.focus(); }catch(_){} } }, 60);
  }
  function close(via) {
    var d=drawer(); if(!d || isStatic(d)) return;
    closeEpoch++;
    resetDrag();
    if(d.contains(document.activeElement) && document.activeElement.blur) document.activeElement.blur(); // avoid aria-hidden on focused descendant
    d.setAttribute('aria-hidden','true');
    lockPage(false);
    document.documentElement.classList.remove('pncart-open');
    popCartState();
    clearInterval(stuckTimer); if(openedAt) tel('close',{pncart_via:via||'unknown', pncart_secs:Math.round((Date.now()-openedAt)/1000)});
    if(lastFocus && document.contains(lastFocus) && lastFocus.focus){ try{ lastFocus.focus({preventScroll:true}); }catch(e){ try{ lastFocus.focus(); }catch(_){} } }
    lastFocus=null;
    try{ document.dispatchEvent(new CustomEvent('pncart:close')); }catch(e){}   // the welcome popup waits for this
  }

  /* ---------- section rendering ---------- */
  function panelFrom(html){ var t=document.createElement('div'); t.innerHTML=html; return t.querySelector('[data-pncart] .pncart__panel'); }
  function applyPanel(html){
    var fresh=panelFrom(html), cur=$('[data-pncart] .pncart__panel');
    if(!fresh || !cur) return false;
    if(!fresh.querySelector('[data-pncart-close]') || !fresh.querySelector('[data-pncart-body]')){
      try{ console.error('[pncart] refused malformed panel', String(html).slice(0,200)); }catch(e){}
      return false;                                   // Liquid error / stripped render: keep the DOM we have, the X stays
    }
    var fb=fresh.querySelector('[data-pncart-body]'), cb=cur.querySelector('[data-pncart-body]');
    var ff=fresh.querySelector('.pncart__foot'), cf=cur.querySelector('.pncart__foot');
    if(fb && cb){
      var st=cb.scrollTop;
      if(cb.innerHTML!==fb.innerHTML) cb.innerHTML=fb.innerHTML;   // header + X are never replaced
      if(cf && !ff) cf.parentNode.removeChild(cf);
      else if(ff && !cf) cur.appendChild(ff);
      else if(ff && cf && cf.innerHTML!==ff.innerHTML) cf.innerHTML=ff.innerHTML;
      cb.scrollTop=st;                                // keep the list where the shopper was
    } else {
      resetDrag();                                    // header is about to be replaced: drop the gesture
      cur.innerHTML=fresh.innerHTML;                  // markup shape changed: full swap as before
    }
    fillDynamic();
    setCartBusy(mutationCount>0); showSwapReview();
    var d=drawer();
    if(d && isStatic(d)){
      if(!cur.contains(document.activeElement)){ var h=cur.querySelector('.pncart__title'); if(h){ h.setAttribute('tabindex','-1'); setTimeout(function(){ try{ h.focus(); }catch(e){} }, 0); } }
    } else if(d && d.getAttribute('aria-hidden')==='false' && !cur.contains(document.activeElement)){
      var x=cur.querySelector('[data-pncart-close]'); if(x) setTimeout(function(){ try{ x.focus({preventScroll:true}); }catch(e){} }, 0);
    }
    return true;
  }
  function getSection(){
    return pnFetch(SEC_URL + '?sections=' + SECTION, {headers:{Accept:'application/json'}})
      .then(function(r){ if(!r.ok || !isJson(r)) throw new Error('sections failed '+r.status); return r.json(); })
      .then(function(j){ return j[SECTION]; });
  }
  // quiet=true: pozadinski refresh (otvaranje ikonom) - panel na ekranu je i dalje ispravan, bez toasta
  function refresh(quiet, fromMutation){
    if(mutationCount && !fromMutation) return Promise.resolve();
    var my=++seq;
    return getSection().then(function(h){ if(my!==seq) return; if(!applyPanel(h)) throw new Error('empty section'); if(needsCartRefresh) markCartNeedsRefresh(false); })
      .catch(function(err){
        try{ console.error('[pncart refresh FAIL]', (err&&err.message)||err); }catch(_){}
        tel('refresh_fail',{pncart_m:String((err&&err.message)||err).slice(0,60)});
        var d=drawer(); if(!quiet && d && !isStatic(d) && d.getAttribute('aria-hidden')==='false') pnToast('Could not refresh your cart. Please reload the page.');
      });
  }

  function mutate(endpoint, body){
    body.sections = sectionList(); body.sections_url = SEC_URL;
    var my=++seq;
    return pnFetch(root + endpoint, {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify(body)
    }).then(function(r){
      if(!isJson(r)){ tel('nonjson',{pncart_s:endpoint}); throw new Error(endpoint+' non-JSON '+r.status); }
      if(!r.ok) return r.json().then(function(d){ throw new Error(endpoint+' '+r.status+': '+((d&&d.description)||(d&&d.message)||'failed')); }, function(){ throw new Error(endpoint+' '+r.status); });
      return r.json();
    }).then(function(j){
      if(j && j.sections && HEADER_SECTION && j.sections[HEADER_SECTION]) syncCartIcon(j.sections[HEADER_SECTION]);
      if(my<seq) return j;                            // a newer request will paint
      var html=j && j.sections && j.sections[SECTION];
      return (html && applyPanel(html)) ? j : refresh(false,true).then(function(){ return j; });
    });
  }
  function getCart(){ return pnFetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){ if(!r.ok || !isJson(r)) throw new Error('cart.js failed '+r.status); return r.json(); }); }

  /* ---------- fill dynamic bits (per-cap, sub savings, upsell) ---------- */
  function fillDynamic(){
    $$('[data-pncart-item]').forEach(function(item){
      var size=SIZE[item.dataset.variant], mode=item.dataset.mode;
      if(!size) return;
      var pc=$('[data-pncart-percap]', item);
      if(pc) pc.textContent = money(PERCAP[mode][size]) + ' per day'; // 2026-09-02: isti rjecnik kao buy box (1 kapsula = 1 dan)
    });
    $$('[data-pncart-subcard]').forEach(function(card){
      var item=$('[data-pncart-item][data-line="'+card.dataset.line+'"]'); if(!item) return;
      var size=SIZE[item.dataset.variant]; if(!size) return;
      if(!SAVE[size] || !PLANS[size]){ card.hidden=true; return; }   // nema pretplate u ponudi za ovu velicinu
      var el=$('[data-pncart-subsave]', card); if(el) el.textContent=money(SAVE[size]);
      var pe=$('[data-pncart-subpct]', card); if(pe) pe.textContent=Math.floor(SAVE[size]/PRICE.onetime[size]*100)+'%';
    });
    $$('[data-pncart-upsell]').forEach(function(box){
      var item=$('[data-pncart-item][data-line="'+box.dataset.line+'"]'); if(!item){ box.hidden=true; return; }
      var qn=item.querySelector('[data-pncart-qtynum]'); var qty=qn?(parseInt(qn.textContent,10)||1):1;
      buildUpsell(box, SIZE[item.dataset.variant], item.dataset.mode, item.dataset.plan||'', qty);
    });
    $$('[data-pncart-manage]').forEach(function(box){
      var item=$('[data-pncart-item][data-line="'+box.dataset.line+'"]'); if(!item){ box.hidden=true; return; }
      buildManage(box, SIZE[item.dataset.variant], item.dataset.mode, item.dataset.plan||'');
    });
  }

  function packsWord(n){ return n===2?'two':n===3?'three':String(n); }
  function buildUpsell(box, size, mode, plan, qty){
    if(!size){ box.hidden=true; return; }
    qty = qty || 1;
    // 2026-09-02 audit: qty x manji paket je SKUPLJE od veceg paketa (2x30 sub = $79.98 vs 60-day $69.99,
    // 3x30 = $119.97 vs 90-day $89.99), a per-unit upsell ("Add 30 more +$30") uz qty 3 nema smisla.
    // Cist merge (ukupno kapsula == postojeci paket) -> "Switch to the N-day pack, save $X" (qty 1 na novom redu).
    if(qty>1){
      var total=size*qty;
      if(BYSIZE[total] && total>size && OFFER[mode] && OFFER[mode].indexOf(total)!==-1){
        var packPrice=PRICE[mode][total], cartPrice=qty*PRICE[mode][size], saveM=cartPrice-packPrice;
        box.hidden=false; box.dataset.target=total;
        box.innerHTML =
          '<div class="pncart__up-head">Same '+total+' capsules for '+money(packPrice)+'</div>'+
          '<div class="pncart__up-sub">'+qty+' x '+size+'-day comes to '+money(cartPrice)+'. The '+total+'-day pack is '+money(packPrice)+(mode==='sub'?', charged and shipped every '+total+' days':'')+'.</div>'+
          '<div class="pncart__up-save-row"><span class="pncart__up-save">Save '+money(saveM)+'</span></div>'+
          '<button class="pncart__up-btn" data-pncart-upgrade data-line="'+box.dataset.line+'" data-target="'+total+'" data-mode="'+mode+'" data-plan="'+plan+'" data-qty="1">Switch to the '+total+'-day pack</button>';
        return;
      }
      box.hidden=true; box.innerHTML=''; return;   // qty>1 bez cistog merge-a: per-unit upsell bi zbunjivao
    }
    var targets = (OFFER[mode]||[]).filter(function(s){ return s>size; });
    if(!targets.length){ box.hidden=true; box.innerHTML=''; return; }
    box.hidden=false;
    var target = parseInt(box.dataset.target,10);
    if(targets.indexOf(target)===-1) target=targets[0];
    box.dataset.target=target;

    var inc = PRICE[mode][target] - PRICE[mode][size];
    var save = (target/30)*PRICE[mode][30] - PRICE[mode][target];
    var tabs = targets.map(function(t){
      return '<button class="pncart__tab '+(t===target?'pncart__tab--active':'')+'" data-pncart-tab data-line="'+box.dataset.line+'" data-target="'+t+'">'+t+'-day</button>';
    }).join('');
    box.innerHTML =
      '<div class="pncart__tabs">'+tabs+'</div>'+
      '<div class="pncart__up-head">Add '+(target-size)+' more capsules +'+money(inc)+'</div>'+
      '<div class="pncart__up-sub">Only '+money(PERCAP[mode][target])+' a day, down from '+money(PERCAP[mode][size])+'. '+SUPPLY[target]+(mode==='sub'?', '+money(PRICE[mode][target])+' charged every '+target+' days':'')+'.</div>'+
      '<div class="pncart__up-save-row"><span class="pncart__up-save">Save '+money(save)+' vs '+packsWord(target/30)+(mode==='sub'?' monthly deliveries':' 30-day packs')+'</span></div>'+
      '<button class="pncart__up-btn" data-pncart-upgrade data-line="'+box.dataset.line+'" data-target="'+target+'" data-mode="'+mode+'" data-plan="'+plan+'">Upgrade to '+target+' caps</button>';
  }

  function buildManage(box, size, mode, plan){
    if(!size){ box.hidden=true; box.innerHTML=''; return; }
    var line = box.dataset.line, parts = [];
    // downsize links - only sizes smaller than the current one (upgrades stay in the prominent block above)
    (OFFER[mode]||[]).filter(function(s){ return s < size; }).forEach(function(s){
      parts.push('<button type="button" class="pncart__manage-link" data-pncart-downsize data-line="'+line+'" data-target="'+s+'" data-mode="'+mode+'" data-plan="'+plan+'">'+s+' caps</button>');
    });
    // switch off subscription - only when the line is currently a subscription
    if(mode==='sub' && OFFER.onetime.indexOf(size)!==-1){   // one-time postoji samo kao 30-day
      parts.push('<button type="button" class="pncart__manage-link" data-pncart-onetime data-line="'+line+'">one-time purchase</button>');
    }
    if(!parts.length){ box.hidden=true; box.innerHTML=''; return; }
    box.hidden=false;
    box.innerHTML = '<span class="pncart__manage-label">Switch to</span> ' + parts.join('<span class="pncart__manage-sep">&middot;</span>');
  }

  /* ---------- actions: fresh identity + serialized mutations ---------- */
  function stableProperties(value){
    var obj={};
    if(Array.isArray(value)){ value.forEach(function(pair){ if(Array.isArray(pair) && pair.length>1) obj[String(pair[0])]=pair[1]; }); }
    else if(value && typeof value==='object'){ Object.keys(value).forEach(function(k){ obj[k]=value[k]; }); }
    return JSON.stringify(Object.keys(obj).filter(function(k){ return obj[k]!=null && String(obj[k])!==''; }).sort().map(function(k){ return [k,String(obj[k])]; }));
  }
  function identity(item){
    var allocation=item.selling_plan_allocation;
    return {variant:String(item.variant_id||item.id),plan:allocation && allocation.selling_plan ? String(allocation.selling_plan.id) : '',properties:stableProperties(item.properties),key:item.key||''};
  }
  function sameIdentity(item,ref){ var own=identity(item); return own.variant===ref.variant && own.plan===ref.plan && own.properties===ref.properties; }
  function lineRef(line){
    var item=$('[data-pncart-item][data-line="'+line+'"]',drawer());
    if(!item) throw cartError('Your cart changed. Please review it and try again.');
    var props; try{ props=JSON.parse(item.dataset.properties||'{}'); }catch(e){ throw cartError('Please reload the page to refresh your cart.'); }
    return {key:item.dataset.key||'',variant:String(item.dataset.variant),plan:item.dataset.plan||'',properties:stableProperties(props)};
  }
  function findLine(cart,ref,optional){
    var matches=[];
    (cart.items||[]).forEach(function(it,i){ if(sameIdentity(it,ref)) matches.push({item:it,line:i+1}); });
    if(ref.key){ var exact=matches.filter(function(m){ return m.item.key===ref.key; }); if(exact.length===1) return exact[0]; }
    if(matches.length===1) return matches[0];
    if(!matches.length && optional) return null;
    throw cartError('Your cart changed. Please review the items before trying again.');
  }
  function quantityFor(cart,ref){ var match=findLine(cart,Object.assign({},ref,{key:''}),true); return match ? match.item.quantity : 0; }
  function removeLine(ref){
    return getCart().then(function(c){ var hit=findLine(c,ref); return mutate('cart/change.js',{id:hit.item.key,quantity:0}); });
  }
  function changeQuantity(ref,dir){
    return getCart().then(function(c){ var hit=findLine(c,ref), next=hit.item.quantity+(dir==='inc'?1:-1); return mutate('cart/change.js',{id:hit.item.key,quantity:Math.max(0,next)}); });
  }
  function setSubscription(ref,on){
    return getCart().then(function(c){
      var hit=findLine(c,ref), size=SIZE[hit.item.variant_id||hit.item.id], sp=null;
      if(on){ var np=PLANS[size] && PLANS[size][SIZE_FREQ[size]||'1']; if(!np) throw cartError('This subscription is unavailable. Please choose another pack.'); sp=parseInt(np,10); }
      // Shopify requires a fresh line index when changing selling_plan. Other actions use the current key.
      return mutate('cart/change.js',{line:hit.line,quantity:hit.item.quantity,selling_plan:sp});
    });
  }
  function swapState(cart,swap){
    var source=quantityFor(cart,swap.source), target=quantityFor(cart,swap.target);
    if(target===swap.targetQuantity+swap.quantity && source===0) return 'done';
    if(target===swap.targetQuantity+swap.quantity && source===swap.sourceQuantity) return 'remove';
    if(target===swap.targetQuantity && source===swap.sourceQuantity) return 'not-added';
    return 'review';
  }
  function recoverSwap(){
    var swap=pendingSwap; if(!swap) return Promise.resolve();
    return getCart().then(function(c){
      var state=swapState(c,swap);
      if(state==='done' || (state==='not-added' && swap.addStatus==='rejected')){ saveSwap(null); return refresh(false,true); }
      if(state==='not-added') throw cartError('We could not confirm whether the new pack was added. Review the current cart before choosing Keep the items shown.');
      if(state!=='remove') throw cartError('Your cart has changed. Review the items, then choose Keep the items shown or contact us for help.');
      var old=findLine(c,Object.assign({},swap.source,{key:''}));
      return mutate('cart/change.js',{id:old.item.key,quantity:0}).catch(function(){
        // A failed response can still follow a successful server change. Never repeat the add.
      }).then(function(){ return getCart(); }).then(function(after){
        if(swapState(after,swap)==='done'){ saveSwap(null); return refresh(false,true); }
        throw cartError('The new pack is in your cart, but the previous pack may still be there. Check the pack change before continuing.');
      });
    }).catch(function(err){
      showSwapReview();
      if(err && err.cartMessage) throw err;
      throw cartError('We could not confirm your pack change. Please check it again before continuing.');
    });
  }
  function upgrade(ref,target,qtyOverride){
    var newId=BYSIZE[target]; if(!newId) return Promise.reject(cartError('This pack is unavailable. Please choose another size.'));
    return getCart().then(function(c){
      var old=findLine(c,ref).item, source=identity(old), q=qtyOverride||old.quantity;
      if(qtyOverride && SIZE[source.variant]*old.quantity!==target*qtyOverride) throw cartError('Your cart quantity changed. Please review the updated pack options.');
      var props={}; JSON.parse(source.properties).forEach(function(pair){ props[pair[0]]=pair[1]; });
      var item={id:newId,quantity:q,properties:props};
      if(source.plan){ var np=PLANS[target] && PLANS[target][SIZE_FREQ[target]]; if(!np) throw cartError('This subscription is unavailable. Please choose another pack.'); item.selling_plan=parseInt(np,10); }
      var targetRef={variant:String(newId),plan:item.selling_plan?String(item.selling_plan):'',properties:source.properties,key:''};
      if(source.variant===targetRef.variant) throw cartError('This pack is already selected.');
      var swap={source:source,target:targetRef,sourceQuantity:old.quantity,targetQuantity:quantityFor(c,targetRef),quantity:q,addStatus:'unknown'};
      saveSwap(swap);
      return pnFetch(root+'cart/add.js',{
        method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[item]})
      }).then(function(r){
        if(!isJson(r)) throw new Error('add response could not be confirmed');
        return r.json().then(function(j){
          if(!r.ok){ if([400,401,403,404,422,429].indexOf(r.status)!==-1){ swap.addStatus='rejected'; saveSwap(swap); } throw new Error((j && j.description)||'add failed'); }
          swap.addStatus='accepted'; saveSwap(swap);
        });
      }).catch(function(){
        // Timeout/non-JSON/error: inspect the actual quantities. Retrying add could duplicate a pack.
      }).then(function(){
        return getCart().then(function(after){
          var state=swapState(after,swap);
          if(state==='not-added'){
            if(swap.addStatus==='rejected'){ saveSwap(null); throw cartError('The new pack was not added. Please try again.'); }
            throw cartError('We could not confirm whether the new pack was added. Review the current cart before choosing Keep the items shown.');
          }
          if(state==='done'){ saveSwap(null); return refresh(false,true); }
          if(state!=='remove') throw cartError('Your cart changed during the pack change. Review the items before continuing.');
          return recoverSwap();
        });
      }).catch(function(err){
        showSwapReview();
        if(err && err.cartMessage) throw err;
        throw cartError('We could not confirm your pack change. The new pack may already be in your cart. Please check the pack change.');
      });
    });
  }

  /* ---------- delegated events (DOM re-renders, so delegate) ---------- */
  document.addEventListener('click', function(e){
    var t;
    if((t=e.target.closest('[data-pncart-close]'))){ e.preventDefault(); close('x'); return; }
    if(e.target===drawer() && !isStatic(drawer())){ close('backdrop'); return; } // click on the dimmed backdrop closes the cart
    // 2026-07-12: empty-state CTA/kartica vode na /products/purenadh#offer90 - ako je kupac
    // VEC na toj stranici, browser ne navigira (isti URL+hash) pa je izgledalo da dugme ne radi.
    // Fix: zatvori drawer i skrolaj do buy boxa; s drugih stranica normalna navigacija.
    if((t=e.target.closest('.pncart__empty-cta, .pncart__empty-card'))){
      var eh=(t.getAttribute('href')||'').split('#')[0].replace(/\/$/,'');
      if(eh && location.pathname.replace(/\/$/,'')===eh){
        e.preventDefault(); close('empty-cta');
        var target=document.getElementById('offer90-target')||document.getElementById('offer90')||document.getElementById('pg2-main');
        if(target){ setTimeout(function(){ target.scrollIntoView({behavior:'smooth', block:'start'}); }, 80); }
      }
      return;
    }
    if((t=e.target.closest('.pncart__checkout'))){
      if(mutationCount || pendingSwap || needsCartRefresh){ e.preventDefault(); if(!mutationCount) queueMutation(function(){ return pendingSwap?recoverSwap():refreshConfirmedCart(); },true).catch(function(err){ showCartError(err,'Please check your cart before continuing.'); }); return; }
      if(e.defaultPrevented || e.button!==0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;   // Normal modified clicks remain available once the cart is confirmed.
      if(!t.dataset.pnGoing){ t.dataset.pnGoing='1'; t.dataset.pnLabel=t.innerHTML; t.style.pointerEvents='none'; t.innerHTML='<span class="pncart-dots"><span></span><span></span><span></span></span>'; setTimeout(resetCheckout, 8000); tel('checkout'); }
      return;
    } // dots while the checkout page loads (no preventDefault - let it navigate)
    if((t=e.target.closest('[data-pncart-open]')) ||
       (t=e.target.closest('#cart-icon-bubble')) ||
       (t=e.target.closest('a[href$="/cart"]'))){
      e.preventDefault(); open('icon'); refresh(true); return;
    }
    if((t=e.target.closest('[data-pncart-recover]'))){
      e.preventDefault(); if(mutationCount) return;
      queueMutation(function(){ return pendingSwap?recoverSwap():refreshConfirmedCart(); },true).catch(function(err){ showCartError(err,'Please check your connection and try again.'); }); return;
    }
    if((t=e.target.closest('[data-pncart-keep]'))){
      e.preventDefault(); if(mutationCount) return;
      // This explicit acknowledgement accepts only a fresh, successfully rendered server cart.
      queueMutation(function(){ return getSection().then(function(h){ if(!applyPanel(h)) throw new Error('cart unavailable'); saveSwap(null); }); },true)
        .catch(function(err){ showCartError(err,'Could not check the current cart. Please try again.'); }); return;
    }
    if((t=e.target.closest(MUTABLE))){
      if(t.hasAttribute('data-pncart-subtoggle')) return;
      e.preventDefault(); if(mutationCount) return;
      if(t.hasAttribute('data-pncart-tab')){
        var box=$('[data-pncart-upsell][data-line="'+t.dataset.line+'"]',drawer());
        if(box){ box.dataset.target=t.dataset.target; fillDynamic(); } return;
      }
      var ref; try{ ref=lineRef(t.dataset.line); }catch(err){ showCartError(err,'Please reload your cart.'); return; }
      var work, fallback='Could not update your cart. Please try again.';
      if(t.hasAttribute('data-pncart-remove')) work=function(){ return removeLine(ref); };
      else if(t.hasAttribute('data-pncart-qty')){ var dir=t.dataset.pncartQty; work=function(){ return changeQuantity(ref,dir); }; }
      else if(t.hasAttribute('data-pncart-upgrade')||t.hasAttribute('data-pncart-downsize')){
        var target=parseInt(t.dataset.target,10), qty=t.dataset.qty?parseInt(t.dataset.qty,10):0;
        work=function(){ return upgrade(ref,target,qty); };
      } else if(t.hasAttribute('data-pncart-onetime')) work=function(){ return setSubscription(ref,false); };
      if(work) queueMutation(work).catch(function(err){ showCartError(err,fallback); });
      return;
    }
  });

  // Removing href also blocks context-menu navigation; auxclick covers middle-click during a pending change.
  document.addEventListener('auxclick',function(e){ if((mutationCount || pendingSwap || needsCartRefresh) && e.target.closest('.pncart__checkout, [data-pncart-express]')){ e.preventDefault(); e.stopImmediatePropagation(); } },true);

  // Cart icon -> open drawer (CAPTURE phase, so it beats theme/app handlers that stop propagation)
  document.addEventListener('click', function(e){
    if (e.target.closest('#cart-icon-bubble, .header__icon--cart, [data-pncart-open]')){
      e.preventDefault(); e.stopPropagation(); open('icon'); refresh(true);
    }
  }, true);

  // Checkout gumb: tockice ostaju ako navigacija ne prodje (bfcache Back, otkazano) - resetiraj
  function resetCheckout(){
    $$('[data-pncart] .pncart__checkout[data-pn-going]').forEach(function(a){
      delete a.dataset.pnGoing; a.style.pointerEvents='';
      if(a.dataset.pnLabel!=null){ a.innerHTML=a.dataset.pnLabel; delete a.dataset.pnLabel; }
    });
  }
  window.addEventListener('pageshow', function(ev){
    try{ var d0=drawer(); if(history.state && history.state.pncart && !(d0 && !isStatic(d0) && d0.getAttribute('aria-hidden')==='false')) history.replaceState(null, ''); }catch(e){}
    if(!ev.persisted) return;
    resetCheckout(); resetDrag();
    var d=drawer(); if(d && !isStatic(d) && d.getAttribute('aria-hidden')==='false') refresh(true);   // cart may have changed on checkout
  });
  window.addEventListener('pagehide', resetCheckout);
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) resetCheckout(); });

  document.addEventListener('change', function(e){
    var t=e.target.closest('[data-pncart-subtoggle]'); if(!t) return;
    var want=t.checked; t.checked=!want; // Keep confirmed state visible while Shopify processes the change.
    if(mutationCount) return;
    var ref; try{ ref=lineRef(t.dataset.line); }catch(err){ showCartError(err,'Please reload your cart.'); return; }
    queueMutation(function(){ return setSubscription(ref,want); }).catch(function(err){ showCartError(err,'Could not update subscription. Please try again.'); });
  });

  // Swipe-to-dismiss (mobile bottom sheet): drag the header/handle down to close.
  // 2026-09-06: touchcancel/orientationchange/visibilitychange reset, 8px slop, single finger by id, controls never start a drag,
  // drawer must still be open during move. Prije: prekinuta gesta (OS preuzme dodir) ostavljala je panel pomaknut bez tranzicije.
  (function(){
    var startY=null, curY=0, dragging=false, moved=false, p=null, tid=null;
    function byId(list,id){ for(var i=0;i<list.length;i++){ if(list[i].identifier===id) return list[i]; } return null; }
    resetDrag=function(){ if(p){ p.style.transition=''; p.style.transform=''; } dragging=false; moved=false; startY=null; curY=0; p=null; tid=null; };
    document.addEventListener('touchstart', function(e){
      if(dragging){ if(byId(e.touches, tid)) return; resetDrag(); }   // stale state from a lost touchend: recover, then treat as a fresh touch
      if(window.innerWidth>480 || e.touches.length!==1) return;       // mobile sheet only, single finger
      var d=drawer(); if(!d || isStatic(d) || d.getAttribute('aria-hidden')!=='false') return;
      if(!e.target.closest('.pncart__head')) return;
      if(e.target.closest('[data-pncart-close], button, a')) return; // the X never starts a drag
      p=$('[data-pncart] .pncart__panel'); if(!p) return;
      var t=e.changedTouches[0]; tid=t.identifier; startY=t.clientY; curY=0; moved=false; dragging=true;
    }, {passive:true});
    document.addEventListener('touchmove', function(e){
      if(!dragging || !p) return;
      var d=drawer(); if(!d || d.getAttribute('aria-hidden')!=='false'){ resetDrag(); return; }
      var t=byId(e.touches, tid); if(!t){ resetDrag(); return; }
      var dy=t.clientY-startY;
      if(!moved){ if(Math.abs(dy)<8) return; moved=true; p.style.transition='none'; }   // 8px slop: a wobbly tap stays a tap
      if(dy<0) dy=0; curY=dy;
      p.style.transform='translateY('+dy+'px)';
      if(e.cancelable) e.preventDefault();
    }, {passive:false});
    function endDrag(e){
      if(!dragging) return;
      if(e && e.touches && byId(e.touches, tid)) return;               // our finger is still down: another finger lifted
      var go=!!(e && e.type==='touchend') && curY>120;
      if(e && e.type==='touchcancel'){ tel('touchcancel',{pncart_dy:Math.round(curY)}); }
      resetDrag();
      if(go) close('swipe');
    }
    document.addEventListener('touchend', endDrag, {passive:true});
    document.addEventListener('touchcancel', endDrag, {passive:true});
    window.addEventListener('orientationchange', function(){ resetDrag(); });
    document.addEventListener('visibilitychange', function(){ if(document.hidden) resetDrag(); });
  })();

  // Esc to close + focus trap while open
  document.addEventListener('keydown', function(e){
    var d=drawer(); if(!d || isStatic(d) || d.getAttribute('aria-hidden')!=='false') return;
    if(document.documentElement.classList.contains('pnwp-open')) return;   // the popup is on top: it owns Escape/Tab
    if(e.key==='Escape'){ close('esc'); return; }
    if(e.key!=='Tab') return;
    var f=focusable(); if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    var pp=$('[data-pncart] .pncart__panel'); if(pp && !pp.contains(document.activeElement)){ e.preventDefault(); first.focus(); return; }
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  });

  /* ---------- intercept Add to cart (PDP) -> ajax + open drawer ---------- */
  document.addEventListener('submit', function(e){
    var form=e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();              // stop Dawn product-form (no double add, no cart-notification)
    if(mutationCount) return;
    var submittedCloseEpoch=closeEpoch;
    // instant feedback ON THE BUTTON: animated dots while adding; cart opens only when done
    var btn=e.submitter||form.querySelector('[type="submit"],button'); var btnHTML=null;
    if(btn){ btnHTML=btn.innerHTML; btn.disabled=true; btn.classList.add('pncart-btn-loading'); btn.innerHTML='<span class="pncart-dots"><span></span><span></span><span></span></span>'; }
    var restoreBtn=function(){ if(btn){ btn.disabled=false; btn.classList.remove('pncart-btn-loading'); if(btnHTML!=null) btn.innerHTML=btnHTML; } };
    var fd=new FormData(form);
    fd.append('sections', sectionList()); fd.append('sections_url', SEC_URL);
    queueMutation(function(){
      var my=++seq; // Capture inside the queue, after it invalidates older background requests.
      return pnFetch(root+'cart/add.js', { method:'POST', headers:{Accept:'application/json'}, body:fd })
      .then(function(r){
        if(!isJson(r)) return {ok:false, challenge:r.status<400, j:null};   // HTML 2xx/3xx = bot challenge; HTML 5xx = plain failure
        return r.json().then(function(j){ return {ok:r.ok, j:j}; }, function(){ return {ok:false, j:null}; });
      })
      .then(function(res){
        if(res.challenge){ tel('nonjson',{pncart_s:'add'}); restoreBtn(); form.submit(); return; }   // bot challenge: native POST, Shopify shows it and lands on /cart
        if(!res.ok){                                               // 422 i sl.: NE otvaraj drawer, reci korisniku sta je bilo
          restoreBtn();
          pnToast((res.j && (res.j.description || res.j.message)) || 'Could not add to cart. Please try again.');
          return;
        }
        var j=res.j || {};
        var html=j.sections && j.sections[SECTION];
        var painted=my===seq && html && applyPanel(html), ready;
        if(painted) ready=Promise.resolve();
        else {
          // Shopify can add successfully while bundled sections fail. Do not unlock a stale panel or suggest another add.
          markCartNeedsRefresh(true);
          ready=refreshConfirmedCart().catch(function(){
            var err=cartError('Your item was added, but your cart could not be refreshed. Use the cart icon to refresh it before adding again.'); err.noRefresh=true; throw err;
          });
        }
        return ready.then(function(){
          if(j.sections && HEADER_SECTION && j.sections[HEADER_SECTION]) syncCartIcon(j.sections[HEADER_SECTION]);
          restoreBtn(); if(closeEpoch===submittedCloseEpoch) open('atc');
        });
      });
    }).then(restoreBtn, function(err){ restoreBtn(); showCartError(err,'Could not add to cart. Please check your connection and try again.'); });
  }, true);

  /* ---------- init ---------- */
  fillDynamic(); showSwapReview(); syncCheckoutAvailability();
  window.PNCart = { open:function(){ open('api'); refresh(true); }, close:function(){ close('api'); }, refresh:refresh };
  document.addEventListener('cart:updated', function(e){ var src=e && e.detail && e.detail.source; var d=drawer(); if(d && !isStatic(d) && src==='sticky-bar') open('event'); refresh(true); });
  try { console.log('[cart-drawer-pn] active'); } catch(e){}
})();
